{
  "todayButton": "Днес",
  "nextMonth": "Следващ месец",
  "previousMonth": "Предишен месец",
  "nextYear": "Следваща година",
  "previousYear": "Предишна година",
  "weekdays": [
    "Неделя",
    "Понеделник",
    "Вторник",
    "Сряда",
    "Четвъртък",
    "Петък",
    "Събота"
  ],
  "months": [
    "Януари",
    "Февруари",
    "Март",
    "Април",
    "Май",
    "Юни",
    "Юли",
    "Август",
    "Септември",
    "Октомври",
    "Ноември",
    "Декември"
  ]
}
